import React, { useCallback } from "react";

import {
	ClassificationCodeQuestionTypeSelector
} from "containers/Form/SimplifiedBuilder/Components/ClassificationCode/ClassificationCodeQuestionTypeSelector";
import { CAYUSE_TYPES, DEFAULT_MAXIMUM_BY_CLASSIFICATION_CODE_TYPE } from "globals/constants";

import { QuestionFooter, QuestionHeader } from "../Question";
import { ClassificationCodeCustomSettings } from "./ClassificationCodeCustomSettings";
import ClassificationCodePreview from "./ClassificationCodePreview";

const ClassificationCodeComponent = ({ completeFormModel, config, onChange, onDelete }) => {
	const onChangeConfig = useCallback(
		newProps => onChange(config => ({ ...config, ...newProps })),
		[ onChange ],
	);

	return (
		<>
			<QuestionHeader config={config} onChangeConfig={onChangeConfig}/>
			<div className="ui form">
				<ClassificationCodePreview {...config.extraSettings} {...config} />
			</div>
			<QuestionFooter
				completeFormModel={completeFormModel}
				config={config}
				CustomSettingsComponent={ClassificationCodeCustomSettings}
				QuestionTypeSelector={ClassificationCodeQuestionTypeSelector}
				onChangeConfig={onChangeConfig}
				onDelete={onDelete}
			/>
		</>
	);
};

ClassificationCodeComponent.showInPalette = () => true;

ClassificationCodeComponent.paletteInformation = () => ({
	id: "classificationCodes",
	name: "AU NZ Classification Code",
	type: "classificationCodes",
	group: "sponsoredProject"
});

ClassificationCodeComponent.newElement = () => ({
	designInfo: {
		stencilSuperIds: [
			"Component"
		],
		stencilId: "cayuse-classification-codes",
		customStencilId: "null"
	},
	type: "classificationCodes",
	cayuseType: CAYUSE_TYPES.CLASSIFICATION_CODES,
	cayuseShortLabel: "",
	extraSettings: {
		codeType: "FOR",
		includePercentage: true,
		forMinimum: 1,
		seoMinimum: 1,
		toaMinimum: 1,
		herdcMinimum: 1,
		forMaximum: DEFAULT_MAXIMUM_BY_CLASSIFICATION_CODE_TYPE.FOR,
		seoMaximum: DEFAULT_MAXIMUM_BY_CLASSIFICATION_CODE_TYPE.SEO,
		toaMaximum: DEFAULT_MAXIMUM_BY_CLASSIFICATION_CODE_TYPE.TOA,
		herdcMaximum: DEFAULT_MAXIMUM_BY_CLASSIFICATION_CODE_TYPE.HERDC,
	}
});

export default ClassificationCodeComponent;
